import React from "react";

import styles from "./WeatherlyLogo.module.scss";

import WeatherlyIcon from "../1_atoms/WeatherlyIcon";

function WeatherlyLogo() {
  return (
    <div className={styles["container"]}>
      <WeatherlyIcon />
      <h1 className={styles["container__heading"]}>Weatherly</h1>
    </div>
  );
}

export default WeatherlyLogo;
